import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { employeesAPI } from '../../services/api';
import toast from 'react-hot-toast';

export default function EmployeeForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: '', last_name: '', email: '', phone: '', hire_date: '',
    job_title: '', department: '', salary: '', pay_frequency: 'Monthly', is_active: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) employeesAPI.get(id).then(d => setForm({ ...d, salary: d.salary ?? '' })).catch(e => toast.error(e.message));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      if (id) { await employeesAPI.update(id, form); toast.success('Employee updated'); }
      else { await employeesAPI.create(form); toast.success('Employee created'); }
      navigate('/employees');
    } catch (err) { toast.error(err.message); }
    setLoading(false);
  };
  const u = (f) => (e) => setForm({ ...form, [f]: e.target.value });

  return (
    <div>
      <div className="toolbar">
        <h2>{id ? 'Edit Employee' : 'New Employee'}</h2>
        <div className="toolbar-right">
          <button type="button" className="btn btn-outline" onClick={() => navigate('/employees')}>Cancel</button>
          <button type="submit" className="btn btn-primary" form="employee-form" disabled={loading}>
            {loading ? 'Saving...' : (id ? 'Update' : 'Create') + ' Employee'}
          </button>
        </div>
      </div>

      <div className="df-editor">
        <div className="df-section-header">
          <span>Personal Information</span>
        </div>
        <form id="employee-form" onSubmit={handleSubmit}>
          <div className="df-body">
            <div className="df-grid cols-2">
              <div className="df-field">
                <label>First Name <span className="req">*</span></label>
                <input required value={form.first_name || ''} onChange={u('first_name')} />
              </div>
              <div className="df-field">
                <label>Last Name <span className="req">*</span></label>
                <input required value={form.last_name || ''} onChange={u('last_name')} />
              </div>
              <div className="df-field">
                <label>Email</label>
                <input type="email" value={form.email || ''} onChange={u('email')} />
              </div>
              <div className="df-field">
                <label>Phone</label>
                <input value={form.phone || ''} onChange={u('phone')} />
              </div>
              <div className="df-field">
                <label>Hire Date</label>
                <input type="date" value={form.hire_date || ''} onChange={u('hire_date')} />
              </div>
            </div>

            <div className="df-divider" />
            <div className="df-section-title">Job &amp; Compensation</div>
            <div className="df-grid cols-2">
              <div className="df-field">
                <label>Job Title</label>
                <input value={form.job_title || ''} onChange={u('job_title')} />
              </div>
              <div className="df-field">
                <label>Department</label>
                <input value={form.department || ''} onChange={u('department')} />
              </div>
              <div className="df-field">
                <label>Salary</label>
                <input type="number" step="0.01" min="0" value={form.salary} onChange={u('salary')} placeholder="0.00" />
              </div>
              <div className="df-field">
                <label>Pay Frequency</label>
                <select value={form.pay_frequency || 'Monthly'} onChange={u('pay_frequency')}>
                  {['Weekly', 'BiWeekly', 'SemiMonthly', 'Monthly'].map(f => <option key={f} value={f}>{f}</option>)}
                </select>
              </div>
              <div className="df-field">
                <label>Status</label>
                <select value={form.is_active ? '1' : '0'} onChange={e => setForm({ ...form, is_active: e.target.value === '1' })}>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
          </div>
          <div className="df-actions">
            <button type="button" className="btn btn-outline" onClick={() => navigate('/employees')}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : (id ? 'Update' : 'Create') + ' Employee'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
